import { useRouter } from 'next/router';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export let pageChanged: boolean;
let setPageChanged: Dispatch<SetStateAction<boolean>>;

/** detect when page changed */
export const usePageChanged = () => {
  [pageChanged, setPageChanged] = useState(false);
  const router = useRouter();
  useEffect(() => {
    const handleRouteChangeStart = () => setPageChanged(false);
    const handleRouteChangeComplete = () => setPageChanged(true);
    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeComplete);
  }, []);
};
